// @ts-nocheck

const open = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('verbos', 1);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('translations')) {
                db.createObjectStore('translations', { keyPath: 'id', autoIncrement: true });
            }
        };

        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        request.onerror = (event) => {
            reject(event.target.error);
        };
    });
}

const dbCurrentVersion = 5;

function LocalDB(database) {

    this.database = database;
    this.table = null;
    this.connection = null;

    this.open = (table) => {
        this.table = table;
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.database, dbCurrentVersion);

            request.onupgradeneeded = (event) => {
                try {
                    const db = event.target.result;
                    if(db.objectStoreNames.contains(table)){
                        db.deleteObjectStore(table);
                    }
                    db.createObjectStore(table, { keyPath: 'id', autoIncrement: false, unique: true });
                } catch (error) {
                    reject(error);
                }
            };

            request.onsuccess = (event) => {
                this.db = event.target.result;
                this.connection = this.db;
                resolve(this.db);
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    };

    this.get = (key) => {
        return new Promise((resolve, reject) => {
            const transaction = this.connection.transaction([this.table], 'readonly');
            const objectStore = transaction.objectStore(this.table);
            const request = objectStore.get(key);

            request.onsuccess = (event) => {
                resolve(event.target.result);
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    };

    this.put = (value) => {
        return new Promise((resolve, reject) => {
            const transaction = this.connection.transaction([this.table], 'readwrite');
            const objectStore = transaction.objectStore(this.table);
            const request = objectStore.put(value);

            request.onsuccess = (event) => {
                resolve(event.target.result);
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    };

    this.count = () => {
        return new Promise((resolve, reject) => {
            const transaction = this.connection.transaction([this.table], 'readonly');
            const objectStore = transaction.objectStore(this.table);
            const request = objectStore.count();

            request.onsuccess = (event) => {
                resolve(event.target.result);
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    };

    this.close = () => {
        if (this.connection) {
            this.connection.close();
        }
    };
}


export default LocalDB;